import * as React from 'react';
import { Menu, Dropdown } from 'antd';
import { MdSort, MdCheck } from 'react-icons/md';
import { IconContext } from "react-icons";

import { COMMENT_SORT } from '@bakbak/common';
import { withAppContext, AppContextProps } from '../../../context/AppContext';
import { THEME_COLOR } from '../../../constants';

class CommentFilterC extends React.PureComponent<AppContextProps> {

  onMenuClick = (key: string) => {
    this.props.context.updateCommentSort(key);
  };

  checkedOption = (commentSort: { key: string; value: string }) => {
    const { key, value } = commentSort;
    const checked = this.props.context.commentSort === key;
    return (
      <Menu.Item key={key} onClick={() => this.onMenuClick(key)}>
        <div style={{ width: 150, marginTop: 2, marginBottom: 2 }}>
          {checked &&
            <IconContext.Provider value={{ size: "1em", style: { verticalAlign: 'middle', marginLeft: 5 }, color: THEME_COLOR }}>
              <MdCheck />
            </IconContext.Provider>
          }
          <span style={{ color: checked ? THEME_COLOR : 'black', marginLeft: 3 }}>{value}</span>
        </div>
      </Menu.Item>
    )
  };

  render() {
    const menu = (
      <Menu>
        {this.checkedOption(COMMENT_SORT[0])}
        {this.checkedOption(COMMENT_SORT[1])}
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <span>
          <IconContext.Provider value={{ size: "2em", style: { verticalAlign: 'middle' } }}>
            <MdSort />
            <span style={{ fontSize: '1.1em' }}> SORT BY</span>
          </IconContext.Provider>
        </span>
      </Dropdown>
    );
  }
}

export const CommentFilterView = withAppContext(CommentFilterC)


// WEBPACK FOOTER //
// ./src/modules/comment/filter/CommentFilterView.tsx